import { render } from "./AlertModel.vue?vue&type=template&id=d68f79be&scoped=true"
import script from "./AlertModel.vue?vue&type=script&lang=js"
export * from "./AlertModel.vue?vue&type=script&lang=js"

import "./AlertModel.vue?vue&type=style&index=0&id=d68f79be&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d68f79be"]])

export default __exports__